export const SELF_ASSESSMENT_STARTING_POINT = "selfAssessmentStartingPoint";
export const SELF_ASSESSMENT_ASSESSMENT = "selfAssessmentAssessment";
export const SELF_ASSESSMENT_RESULTS = "selfAssessmentResults";
export const SELF_ASSESSMENT_RESULT_TOKEN = "selfAssessment.resultsHash";
